import { useState, useEffect, Suspense, lazy } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { MessageSquare, FileText, Sparkles, Sun, Loader2 } from "lucide-react";

const WeeklysPage = lazy(() => import("./comunicacion/WeeklysPage"));
const ReportsPage = lazy(() => import("./comunicacion/ReportsPage"));
const AIReportsPage = lazy(() => import("./comunicacion/AIReportsPage"));
const AlertsPage = lazy(() => import("./comunicacion/AlertsPage"));

export default function ComunicacionPage() {
  const [params, setParams] = useSearchParams();
  const [tab, setTab] = useState(params.get("tab") || "weeklys");
  useEffect(() => {
    if (tab !== params.get("tab")) setParams({ tab }, { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  return (
    <div className="p-6 space-y-4" data-testid="comunicacion-page">
      <div className="border-b pb-4">
        <div className="text-xs uppercase tracking-widest text-emerald-700 font-semibold mb-1">Innovation OS · Chuletario</div>
        <h1 className="text-2xl font-bold tracking-tight">Chuletario</h1>
        <p className="text-sm text-muted-foreground mt-1">Weeklys del equipo · Reporting operativo · Informes IA · Alertas proactivas.</p>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="space-y-4">
        <TabsList>
          <TabsTrigger value="weeklys" data-testid="com-tab-weeklys"><MessageSquare className="w-4 h-4 mr-2" />Weeklys</TabsTrigger>
          <TabsTrigger value="reporting" data-testid="com-tab-reporting"><FileText className="w-4 h-4 mr-2" />Reporting</TabsTrigger>
          <TabsTrigger value="ia" data-testid="com-tab-ia"><Sparkles className="w-4 h-4 mr-2" />Informes IA</TabsTrigger>
          <TabsTrigger value="alertas" data-testid="com-tab-alertas"><Sun className="w-4 h-4 mr-2" />Alertas</TabsTrigger>
        </TabsList>

        <div className="-mx-6 -mt-2">
          <Suspense fallback={<div className="p-12 flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-emerald-600" /></div>}>
            <TabsContent value="weeklys" className="mt-0"><WeeklysPage /></TabsContent>
            <TabsContent value="reporting" className="mt-0"><ReportsPage /></TabsContent>
            <TabsContent value="ia" className="mt-0"><AIReportsPage /></TabsContent>
            <TabsContent value="alertas" className="mt-0"><AlertsPage /></TabsContent>
          </Suspense>
        </div>
      </Tabs>
    </div>
  );
}
